(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fitbag-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-marquee-track]').forEach(function (track) {
    function tune() {
      var oneSetWidth = track.scrollWidth / 2;
      var pixelsPerSecond = 45;
      var duration = Math.max(oneSetWidth / pixelsPerSecond, 6);
      track.style.setProperty('--fb-marquee-duration', duration + 's');
    }
    tune();
    window.addEventListener('resize', tune);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitbag-order-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var modal = document.getElementById('fitbag-order-modal');
    if (!modal) return;

    var form = document.getElementById('fitbag-order-form');
    var titleEl = document.getElementById('fitbag-order-title');
    var productHidden = document.getElementById('fitbag-producto-hidden');
    var colorHidden = document.getElementById('fitbag-color-hidden');
    var precioHidden = document.getElementById('fitbag-precio-hidden');
    var imagenHidden = document.getElementById('fitbag-imagen-hidden');
    var modalPriceEl = modal.querySelector('[data-fitbag-modal-price]');
    var promoRadios = modal.querySelectorAll('input[name="promocion"]');
    var promoListWrap = modal.querySelector('[data-promo-list-wrap]');
    var promoSummaryWrap = modal.querySelector('[data-promo-summary]');
    var promoSummaryText = modal.querySelector('[data-promo-summary-text]');
    var promoExtHidden = document.getElementById('fitbag-promocion-ext');
    var dualColorWrap = modal.querySelector('[data-dual-color-wrap]');
    var cantidadInput = document.getElementById('fitbag-cantidad');
    var singleSummaryWrap = modal.querySelector('[data-single-summary]');
    var summaryImgEl = modal.querySelector('[data-summary-img]');
    var summaryTextEl = modal.querySelector('[data-summary-text]');
    var currentColorImages = {};

    function updateSingleSummary(detail) {
      if (!singleSummaryWrap) return;
      if (summaryImgEl) {
        summaryImgEl.src = detail.imagen || '';
        summaryImgEl.alt = detail.producto || '';
      }
      if (summaryTextEl) {
        summaryTextEl.textContent = (detail.producto || '') + ' + 3 divisiones removibles + Correa larga con hombrera';
      }
    }

    function updateUnitImages() {
      [1, 2].forEach(function (unitNum) {
        var active = dualColorWrap.querySelector('[data-dual-swatches="' + unitNum + '"] .is-active');
        var colorName = active ? active.getAttribute('data-color-name') : null;
        var img = dualColorWrap.querySelector('[data-dual-img="' + unitNum + '"]');
        if (!img) return;
        var url = (colorName && currentColorImages[colorName]) || imagenHidden.value;
        if (url) {
          img.src = url;
          img.hidden = false;
        } else {
          img.hidden = true;
        }
      });
    }

    function updateColorHiddenFromDual() {
      var u1 = dualColorWrap.querySelector('[data-dual-swatches="1"] .is-active');
      var u2 = dualColorWrap.querySelector('[data-dual-swatches="2"] .is-active');
      var c1 = u1 ? u1.getAttribute('data-color-name') : '';
      var c2 = u2 ? u2.getAttribute('data-color-name') : '';
      colorHidden.value = '1era Maleta: ' + c1 + ', 2da Maleta: ' + c2;
      updateUnitImages();
    }

    function renderDualColorPicker(colores, cantidad, currentColor) {
      if (!dualColorWrap) return;
      var qty = parseInt(cantidad, 10) || 1;
      if (!colores || colores.length < 2 || qty < 2) {
        dualColorWrap.hidden = true;
        return;
      }
      dualColorWrap.hidden = false;
      [1, 2].forEach(function (unitNum) {
        var container = dualColorWrap.querySelector('[data-dual-swatches="' + unitNum + '"]');
        container.innerHTML = '';
        colores.forEach(function (c, idx) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'fitbag-order-form__swatch';
          btn.style.background = c.hex;
          btn.setAttribute('data-color-name', c.name);
          btn.setAttribute('aria-label', c.name);
          var shouldBeActive = currentColor ? (c.name === currentColor) : (idx === 0);
          if (shouldBeActive) btn.classList.add('is-active');
          btn.addEventListener('click', function () {
            container.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-active'); });
            btn.classList.add('is-active');
            updateColorHiddenFromDual();
          });
          container.appendChild(btn);
        });
      });
      updateColorHiddenFromDual();
    }

    function setPrice(price) {
      precioHidden.value = price || '';
      if (modalPriceEl) modalPriceEl.textContent = price ? ('S/ ' + price) : '';
    }

    function syncPriceFromPromo() {
      var checked = modal.querySelector('input[name="promocion"]:checked');
      if (checked) setPrice(checked.getAttribute('data-price'));
    }

    promoRadios.forEach(function (radio) {
      radio.addEventListener('change', syncPriceFromPromo);
    });

    function openModal(detail) {
      titleEl.textContent = detail.producto || 'FitBag';
      productHidden.value = detail.producto || '';
      colorHidden.value = detail.color || '';
      imagenHidden.value = detail.imagen || '';
      currentColorImages = detail.colorImages || {};
      setPrice(detail.precio);
      if (cantidadInput) cantidadInput.value = detail.cantidad || '1';
      renderDualColorPicker(detail.colores, detail.cantidad, detail.color);

      if (dualColorWrap && !dualColorWrap.hidden) {
        if (singleSummaryWrap) singleSummaryWrap.hidden = true;
      } else {
        if (singleSummaryWrap) singleSummaryWrap.hidden = false;
        updateSingleSummary(detail);
      }

      if (detail.promocion) {
        if (promoListWrap) promoListWrap.hidden = true;
        if (promoSummaryWrap) promoSummaryWrap.hidden = false;
        if (promoSummaryText) promoSummaryText.textContent = detail.promocion + ' — S/ ' + detail.precio;
        if (promoExtHidden) promoExtHidden.value = detail.promocion;
      } else {
        if (promoListWrap) promoListWrap.hidden = false;
        if (promoSummaryWrap) promoSummaryWrap.hidden = true;
        if (promoExtHidden) promoExtHidden.value = '';
        if (promoRadios.length) syncPriceFromPromo();
      }

      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-fitbag-buy]');
      if (trigger) {
        var detail = {};
        try { detail = JSON.parse(trigger.getAttribute('data-fitbag-buy')); } catch (err) {}
        openModal(detail);
        if (typeof ttq !== 'undefined') {
          ttq.track('AddToCart', {
            contents: [{
              content_id: detail.producto || 'FitBag',
              content_name: detail.producto || 'FitBag',
              content_type: 'product',
              price: parseFloat(detail.precio) || 0,
              quantity: parseInt(detail.cantidad, 10) || 1
            }],
            value: parseFloat(detail.precio) || 0,
            currency: 'PEN'
          });
        }
        return;
      }
      if (e.target.closest('[data-fitbag-close]')) {
        closeModal();
      }
    });

    modal.querySelectorAll('[data-zone]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var zone = btn.getAttribute('data-zone');
        modal.querySelectorAll('[data-zone]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        document.getElementById('fitbag-zona').value = zone;
        modal.querySelectorAll('[data-zone-field="lima"]').forEach(function (f) { f.hidden = zone !== 'lima'; });
        modal.querySelectorAll('[data-zone-field="provincia"]').forEach(function (f) { f.hidden = zone !== 'provincia'; });
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var submitBtn = form.querySelector('.fitbag-order-form__submit');
      var submitLabel = form.querySelector('[data-fitbag-submit-label]');
      submitBtn.disabled = true;
      submitLabel.textContent = 'Enviando...';

      var fd = new FormData(form);
      var zona = fd.get('zona');
      var codigo = 'FB-' + Date.now().toString(36).toUpperCase().slice(-6);
      var data = {
        codigo: codigo,
        nombre: fd.get('nombre') || '',
        telefono: fd.get('telefono') || '',
        correo: fd.get('correo') || '',
        zona: zona,
        distritoCiudad: zona === 'lima' ? (fd.get('distritoCiudad') || '') : (fd.get('distritoCiudad_prov') || ''),
        direccionAgencia: zona === 'lima' ? (fd.get('direccionAgencia') || '') : (fd.get('direccionAgencia_prov') || ''),
        producto: fd.get('producto') || '',
        color: fd.get('color') || '',
        promocion: fd.get('promocion_ext') || fd.get('promocion') || '',
        precio: fd.get('precio') || '',
        cantidad: fd.get('cantidad') || '1',
        comentario: fd.get('comentario') || ''
      };

      if (typeof ttq !== 'undefined') {
        ttq.track('InitiateCheckout', {
          contents: [{
            content_id: data.producto,
            content_name: data.producto,
            content_type: 'product',
            price: parseFloat(data.precio) || 0,
            quantity: parseInt(data.cantidad, 10) || 1
          }],
          value: parseFloat(data.precio) || 0,
          currency: 'PEN'
        }, { event_id: data.codigo + '-checkout' });
      }

      var webhook = modal.getAttribute('data-webhook');
      var whatsapp = modal.getAttribute('data-whatsapp');

      var lines = [
        'Hola, quiero confirmar mi pedido FitBag (código ' + data.codigo + '):',
        '- Producto: ' + data.producto + (data.color ? (' (' + data.color + ')') : ''),
        data.promocion ? ('- Promoción: ' + data.promocion) : null,
        '- Precio: S/ ' + data.precio,
        '- Cantidad: ' + data.cantidad,
        '- Nombre: ' + data.nombre,
        data.correo ? ('- Correo: ' + data.correo) : null,
        '- Zona: ' + (zona === 'lima' ? 'Lima' : 'Provincia'),
        '- ' + (zona === 'lima' ? 'Distrito' : 'Ciudad') + ': ' + data.distritoCiudad,
        data.direccionAgencia ? ('- ' + (zona === 'lima' ? 'Dirección' : 'Agencia') + ': ' + data.direccionAgencia) : null,
        data.comentario ? ('- Comentario: ' + data.comentario) : null
      ].filter(Boolean).join('\n');
      var whatsappUrl = 'https://wa.me/' + whatsapp + '?text=' + encodeURIComponent(lines);

      // Abrimos la pestaña YA, en el mismo instante del clic (si no, el navegador
      // bloquea la ventana emergente porque llega después de esperar al webhook).
      var waTab = window.open('', '_blank');

      function finish() {
        if (typeof ttq !== 'undefined') {
          ttq.track('CompletePayment', {
            contents: [{
              content_id: data.producto,
              content_name: data.producto,
              content_type: 'product',
              price: parseFloat(data.precio) || 0,
              quantity: parseInt(data.cantidad, 10) || 1
            }],
            value: parseFloat(data.precio) || 0,
            currency: 'PEN'
          }, { event_id: data.codigo });
        }
        if (waTab) {
          waTab.location.href = whatsappUrl;
        } else {
          window.open(whatsappUrl, '_blank');
        }
        submitBtn.disabled = false;
        submitLabel.textContent = 'Realizar pedido ahora';
        closeModal();
        form.reset();
      }

      if (webhook) {
        fetch(webhook, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify(data)
        }).then(finish).catch(finish);
      } else {
        finish();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitbag-pp-features"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function norm(str) { return (str || '').trim().toLowerCase(); }

    document.addEventListener('fitbag:color-change', function (e) {
      var color = norm(e.detail && e.detail.color);
      document.querySelectorAll('.fitbag-ppf__media img').forEach(function (img) {
        var url = null;
        if (color === 'azul' && img.getAttribute('data-color-image-azul')) {
          url = img.getAttribute('data-color-image-azul');
        } else if (color === 'rojo' && img.getAttribute('data-color-image-rojo')) {
          url = img.getAttribute('data-color-image-rojo');
        } else {
          url = img.getAttribute('data-color-image-default');
        }
        if (url && img.src !== url) img.src = url;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitbag-product-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fitbag-card]').forEach(function (card) {
    var swatches = card.querySelectorAll('.fitbag-card__swatch');
    var buyBtn = card.querySelector('[data-fitbag-buy]');
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('is-active'); });
        swatch.classList.add('is-active');
        if (buyBtn) {
          try {
            var payload = JSON.parse(buyBtn.getAttribute('data-fitbag-buy'));
            payload.color = swatch.getAttribute('data-color-name');
            buyBtn.setAttribute('data-fitbag-buy', JSON.stringify(payload));
          } catch (err) {}
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitbag-product-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fitbag-pp').forEach(function (section) {
    var mainMedia = section.querySelector('[data-pp-main]');
    var thumbs = section.querySelectorAll('[data-pp-thumb]');
    var swatches = section.querySelectorAll('.fitbag-pp__swatch');
    var tierInputs = section.querySelectorAll('.fitbag-pp__tier input');
    var buyBtn = section.querySelector('[data-pp-buy]');
    var priceEl = section.querySelector('[data-pp-price]');
    var colorNameEl = section.querySelector('[data-pp-color-name]');
    var colorsBlock = section.querySelector('[data-pp-colors-block]');
    var nameEl = section.querySelector('[data-pp-name]');

    function norm(str) { return (str || '').trim().toLowerCase(); }

    function applyColorFilter(colorName) {
      var target = norm(colorName);
      var mainImgs = mainMedia.querySelectorAll('[data-pp-slide]');
      var visible = [];

      mainImgs.forEach(function (img) {
        var imgColor = norm(img.getAttribute('data-pp-color'));
        var matches = !imgColor || imgColor === target;
        img.classList.toggle('pp-color-hidden', !matches);
        if (matches) visible.push(img.getAttribute('data-pp-slide'));
      });
      thumbs.forEach(function (thumb) {
        var thumbColor = norm(thumb.getAttribute('data-pp-color'));
        var matches = !thumbColor || thumbColor === target;
        thumb.classList.toggle('pp-color-hidden', !matches);
      });

      if (visible.length === 0) {
        mainImgs.forEach(function (img) {
          img.classList.remove('pp-color-hidden');
          visible.push(img.getAttribute('data-pp-slide'));
        });
        thumbs.forEach(function (thumb) { thumb.classList.remove('pp-color-hidden'); });
      }

      var activeImg = mainMedia.querySelector('[data-pp-slide].is-active');
      var activeStillVisible = activeImg && visible.indexOf(activeImg.getAttribute('data-pp-slide')) !== -1;
      if (!activeStillVisible && visible.length) {
        var firstIdx = visible[0];
        mainImgs.forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-pp-slide') === firstIdx);
        });
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-pp-thumb') === firstIdx);
        });
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = thumb.getAttribute('data-pp-thumb');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        mainMedia.querySelectorAll('[data-pp-slide]').forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-pp-slide') === idx);
        });
      });
    });

    function declineColor(c) {
      if (!c) return c;
      if (c.trim().toLowerCase() === 'rojo') return 'Roja';
      return c;
    }

    function updateNameHeading(colorName) {
      if (!nameEl || !colorName) return;
      var base = nameEl.getAttribute('data-product-base');
      if (base) nameEl.textContent = base + ' ' + declineColor(colorName);
    }

    function updateBuyPayload() {
      if (!buyBtn) return;
      var payload = {};
      try { payload = JSON.parse(buyBtn.getAttribute('data-fitbag-buy')); } catch (err) {}
      var activeSwatch = section.querySelector('.fitbag-pp__swatch.is-active');
      if (activeSwatch) payload.color = activeSwatch.getAttribute('data-color-name');
      var checkedTier = section.querySelector('.fitbag-pp__tier input:checked');
      var tierQty = 1;
      if (checkedTier) {
        payload.precio = checkedTier.getAttribute('data-tier-price');
        payload.promocion = checkedTier.getAttribute('data-tier-label');
        payload.cantidad = checkedTier.getAttribute('data-tier-qty') || '1';
        tierQty = parseInt(payload.cantidad, 10) || 1;
      }
      var base = buyBtn.getAttribute('data-product-base');
      if (tierQty >= 2 && payload.promocion) {
        payload.producto = payload.promocion;
      } else if (base && payload.color) {
        payload.producto = base + ' ' + declineColor(payload.color);
      }
      var activeMainImg = mainMedia.querySelector('[data-pp-slide].is-active');
      if (activeMainImg && activeMainImg.src) payload.imagen = activeMainImg.src;
      buyBtn.setAttribute('data-fitbag-buy', JSON.stringify(payload));
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        if (swatch.getAttribute('data-soldout') === 'true') return;
        swatches.forEach(function (s) { s.classList.remove('is-active'); });
        swatch.classList.add('is-active');
        if (colorNameEl) colorNameEl.textContent = swatch.getAttribute('data-color-name');
        applyColorFilter(swatch.getAttribute('data-color-name'));
        updateNameHeading(swatch.getAttribute('data-color-name'));
        document.dispatchEvent(new CustomEvent('fitbag:color-change', { detail: { color: swatch.getAttribute('data-color-name') } }));
        updateBuyPayload();
      });
    });

    tierInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (priceEl) priceEl.textContent = 'S/ ' + input.getAttribute('data-tier-price');
        updateBuyPayload();
      });
    });

    if (colorsBlock) {
      var initialColor = colorsBlock.getAttribute('data-initial-color');
      applyColorFilter(initialColor);
      updateNameHeading(initialColor);
      document.dispatchEvent(new CustomEvent('fitbag:color-change', { detail: { color: initialColor } }));
    }
    updateBuyPayload();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitbag-reels"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fitbag-reels').forEach(function (section) {
    var track = section.querySelector('[data-reels-track]');
    var prevBtn = section.querySelector('[data-reels-prev]');
    var nextBtn = section.querySelector('[data-reels-next]');
    if (!track) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var originalReels = Array.prototype.slice.call(track.querySelectorAll('.fitbag-reel'));
    var canLoop = !reduceMotion && originalReels.length > 1;

    if (canLoop) {
      originalReels.forEach(function (reel) {
        track.appendChild(reel.cloneNode(true));
      });
    }

    function scrollByCard(dir) {
      var card = track.querySelector('.fitbag-reel');
      var amount = card ? card.getBoundingClientRect().width + 16 : 240;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    var paused = false;
    var resumeTimer = null;
    function pauseThenResume() {
      paused = true;
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; }, 2500);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); pauseThenResume(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); pauseThenResume(); });
    track.addEventListener('mouseenter', function () { paused = true; });
    track.addEventListener('mouseleave', function () { paused = false; });
    track.addEventListener('touchstart', pauseThenResume, { passive: true });

    if (canLoop) {
      var setWidth = 0;
      function computeSetWidth() {
        setWidth = 0;
        originalReels.forEach(function (reel) {
          setWidth += reel.getBoundingClientRect().width + 16;
        });
      }
      computeSetWidth();
      window.addEventListener('resize', computeSetWidth);

      function step() {
        if (!paused) {
          track.scrollLeft += 0.6;
          if (track.scrollLeft >= setWidth) {
            track.scrollLeft -= setWidth;
          }
        }
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    section.querySelectorAll('.fitbag-reel').forEach(function (reel) {
      var video = reel.querySelector('[data-reel-video]');
      var soundBtn = reel.querySelector('[data-reel-toggle]');
      if (!video) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.6 });
      io.observe(video);

      if (soundBtn) {
        soundBtn.addEventListener('click', function () {
          video.muted = !video.muted;
          soundBtn.textContent = video.muted ? '🔇' : '🔊';
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
